import React from 'react';
import './destination.css';

function Destination() {
  const destinations = [
    {
      id: 1,
      title: "Galle – A Coastal Colonial Charm",
      description: "The charming coastal city of Galle is famous for its Galle Fort, a UNESCO World Heritage site built by the Portuguese in the 16th century and fortified by the Dutch. Wander through the cobblestone streets lined with colonial buildings, visit the Dutch Reformed Church, and enjoy stunning views of the Indian Ocean. The fort area is a living monument with museums, cafes, and boutique shops.",
      attractions: ["Galle Fort", "Dutch Reformed Church", "Unawatuna Beach", "National Maritime Museum"],
      bestFor: ["Historical exploration", "beaches", "photography", "colonial architecture"],
      image: "/GALLE.jpg"
    },
    {
      id: 2,
      title: "Sigiriya – The Lion Rock Fortress",
      description: "An ancient rock fortress and palace ruins from the 5th century AD, built by King Kasyapa. This UNESCO World Heritage site features the famous Sigiriya frescoes (Cave of the Maidens), mirror wall with ancient graffiti, and extensive water gardens. The summit offers breathtaking 360-degree views of the surrounding jungle and countryside.",
      attractions: ["Sigiriya Rock", "Water Gardens", "Mirror Wall", "Lion's Paw Entrance"],
      bestFor: ["History buffs", "hiking", "ancient architecture", "landscape photography"],
      image: "/sigiriya.jpg"
    },
    {
      id: 3,
      title: "Kandy – The Cultural Capital",
      description: "The last royal capital of Sri Lankan kings, home to the sacred Temple of the Tooth Relic (Sri Dalada Maligawa) which houses Buddha's tooth relic. Surrounded by beautiful hills and Kandy Lake, the city offers traditional Kandyan dance performances, the Royal Botanical Gardens in Peradeniya, and a rich cultural heritage.",
      attractions: ["Temple of the Tooth", "Royal Botanical Gardens", "Kandy Lake", "Kandyan Dance Shows"],
      bestFor: ["Cultural experiences", "spiritual tourism", "nature lovers", "family trips"],
      image: "/kandy.webp"
    },
    {
      id: 4,
      title: "Ella – Scenic Mountain Town",
      description: "A picturesque small town in the hill country nestled in the Badulla District, known for its stunning views, lush tea plantations, and excellent hiking trails. The town offers cool climate and breathtaking scenery including the famous Nine Arch Bridge, Ella Rock, and Little Adam's Peak with panoramic views.",
      attractions: ["Nine Arch Bridge", "Ella Rock", "Little Adam's Peak", "Ravana Falls"],
      bestFor: ["Hiking", "photography", "tea plantation tours", "adventure seekers"],
      image: "/ellarock.jpg"
    },
    {
      id: 5,
      title: "Mirissa – Tropical Beach Paradise",
      description: "Famous for its beautiful crescent-shaped beaches, whale watching opportunities, and vibrant nightlife. Enjoy surfing, snorkeling, and watching spectacular sunsets from the beaches. The area is also known for Coconut Tree Hill offering panoramic ocean views and excellent seafood restaurants.",
      attractions: ["Mirissa Beach", "Whale Watching", "Coconut Tree Hill", "Parrot Rock Bridge"],
      bestFor: ["Beach relaxation", "whale watching", "water sports", "sunset views"],
      image: "/mirissa.jpg"
    },
    {
      id: 6,
      title: "Nuwara Eliya – Little England",
      description: "A cool climate city at 1,868m elevation, surrounded by tea plantations, waterfalls, and colonial architecture. Known as 'Little England' due to its British colonial-era buildings, race course, and temperate climate. Visit tea factories to learn about Ceylon tea production and enjoy the misty mountain atmosphere.",
      attractions: ["Tea Plantations", "Gregory Lake", "Hakgala Botanical Garden", "Victoria Park"],
      bestFor: ["Tea tourism", "cool climate", "colonial architecture", "romantic getaways"],
      image: "/nuwara-eliya.jpg"
    },
    {
      id: 7,
      title: "Anuradhapura – Ancient Kingdom",
      description: "One of the ancient capitals of Sri Lanka (4th century BC to 11th century AD), famous for its well-preserved ruins of ancient Lankan civilization. A UNESCO World Heritage site featuring ancient stupas, palaces, and monasteries. The sacred Sri Maha Bodhi tree is over 2,200 years old, grown from a cutting of the original Bodhi tree under which Buddha attained enlightenment.",
      attractions: ["Sri Maha Bodhi", "Ruwanwelisaya", "Jetavanaramaya", "Abhayagiri Monastery"],
      bestFor: ["Ancient history", "Buddhist pilgrimage", "archaeology", "spiritual journeys"],
      image: "/Anuradhapura.webp"
    },
    {
      id: 8,
      title: "Polonnaruwa – Medieval Capital",
      description: "The second most ancient kingdom of Sri Lanka (11th to 13th century), featuring impressive dagobas, statues, and ancient irrigation systems. This UNESCO World Heritage site showcases the Gal Vihara rock temple with magnificent Buddha statues, the Royal Palace complex, and the massive Parakrama Samudra reservoir built by King Parakramabahu.",
      attractions: ["Gal Vihara", "Royal Palace", "Parakrama Samudra", "Vatadage Circular Relic House"],
      bestFor: ["Historical sites", "ancient art", "medieval architecture", "cultural heritage"],
      image: "/polonnaruwa.jpg"
    },
    {
      id: 9,
      title: "Yala National Park – Wildlife Safari",
      description: "Sri Lanka's most famous national park, known for its high density of leopards and diverse ecosystems including forests, grasslands, and coastal lagoons. Enjoy safari tours to spot elephants, sloth bears, crocodiles, and diverse bird species. The park also has ancient rock inscriptions and the famous Sithulpawwa rock temple.",
      attractions: ["Wildlife Safari", "Leopard Spotting", "Bird Watching", "Sithulpawwa Temple"],
      bestFor: ["Wildlife photography", "safari adventures", "nature enthusiasts", "bird watching"],
      image: "/yala.jpg"
    },
    {
      id: 10,
      title: "Bentota – Beach Resort Town",
      description: "A popular beach resort on the southern coast known for its golden beaches, water sports, and river safaris. The Bentota River offers mangrove tours and bird watching. Perfect for family vacations and romantic getaways with luxury resorts, water sports facilities, and the famous Brief Garden designed by Bevis Bawa.",
      attractions: ["Bentota Beach", "Madu River Safari", "Water Sports", "Brief Garden"],
      bestFor: ["Family vacations", "water sports", "beach relaxation", "river tours"],
      image: "/bentota.jpg"
    },
    {
      id: 11,
      title: "Dambulla – Cave Temple Complex",
      description: "Home to the famous Golden Temple of Dambulla, a UNESCO World Heritage site featuring five cave temples with ancient Buddhist murals and over 150 Buddha statues. The caves date back to the 1st century BC and represent the most extensive cave temple complex in Sri Lanka with well-preserved paintings covering 2,100 square meters.",
      attractions: ["Dambulla Cave Temple", "Golden Temple", "Buddha Statues", "Cave Murals"],
      bestFor: ["Religious tourism", "ancient art", "cultural heritage", "spiritual retreats"],
      image: "/dambulla.jpg"
    },
    {
      id: 12,
      title: "Colombo – Commercial Capital",
      description: "A vibrant city blending modern development with colonial heritage. Explore colorful markets, museums, temples, and enjoy the cosmopolitan dining scene. The city showcases Portuguese, Dutch, and British colonial architecture alongside modern skyscrapers. Key attractions include the Gangaramaya Temple, Galle Face Green promenade, and the National Museum.",
      attractions: ["Gangaramaya Temple", "Galle Face Green", "National Museum", "Pettah Market"],
      bestFor: ["City exploration", "shopping", "culinary experiences", "cultural diversity"],
      image: "/gangarama.jpg"
    }
  ];

  return (
    <div className="destination-container">
      <div className="destination-header">
        <h1 className="destination-title">Discover Sri Lanka</h1>
        <p className="destination-subtitle">Explore magnificent destinations showcasing rich cultural heritage and natural beauty</p>
      </div>
      <div className="destination-grid">
        {destinations.map((destination) => (
          <div key={destination.id} className="destination-card">
            <div className="card-image">
              <img 
                src={destination.image} 
                alt={destination.title}
                onError={(e) => {
                  e.target.src = '/placeholder-image.png'; // Fallback image
                }}
              />
              <div className="image-overlay"></div>
            </div>
            <div className="card-content">
              <div className="card-header">
                <h2 className="card-title">{destination.title}</h2>
                <div className="card-badge">#{destination.id}</div>
              </div>
              <div className="card-body">
                <p className="card-description">{destination.description}</p>
                
                <div className="card-section">
                  <h3 className="section-title">
                    Top Attractions
                  </h3>
                  <ul className="attractions-list">
                    {destination.attractions.map((attraction, index) => (
                      <li key={index} className="attraction-item">
                        <span className="attraction-marker"></span>
                        {attraction}
                      </li>
                    ))}
                  </ul>
                </div>
                
                <div className="card-section">
                  <h3 className="section-title">
                    Best For
                  </h3>
                  <div className="tags-container">
                    {destination.bestFor.map((tag, index) => (
                      <span key={index} className="tag">{tag}</span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Destination;